import { useMemo } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { getFixedCostPath } from "@repo/structure";
import { useEstimateStructure } from "@tools";
import { ColumnFactory, RowContainer } from "./components";

export const FixedPriceRow = observer((cellProps) => {
  const {t} = useTranslation();
  const structure = useEstimateStructure();
  const { turnOffFixedPrice } = structure;
  const { fixedCostTitle } = structure.settings;
  const { hideSummaryFixedCost } = structure.visibility;

  const handleTurnOff = () => {
    structure.setTurnOffFixedPriceState(!turnOffFixedPrice);
  }
  const handleVisibility = () =>
    structure.visibility.setHideSummaryFixedCost(!hideSummaryFixedCost);
  const handleNameChange = (value) =>
    structure.settings.setFixedCostTitle(value);
  
  const commentPath = useMemo(() => getFixedCostPath(), []);
  const title = useMemo(() => (
    fixedCostTitle || t("views.editor.summary_table.fixed_costs")
  ), [fixedCostTitle]);
  
  return (
    <RowContainer
      title={title}
      inputPlaceholder={t("views.editor.summary_table.fixed_costs")}
      commentPath={commentPath}
      onTurnOffChange={handleTurnOff}
      onVisibilityChange={handleVisibility}
      onNameChange={handleNameChange}
      turnOff={turnOffFixedPrice}
      isHidden={hideSummaryFixedCost}
      {...cellProps}
    >
      <ColumnFactory type="fixedCost" />
    </RowContainer>
  );
});